import { Input, Modal } from "antd";
import styles from "../../Services/NewService/NewService.module.css";
import { useState } from "react";
import Button from "../../../components/ui/Button";

const NewStaff = ({ open, closeModal }) => {
  const [state, setState] = useState({
    first_name: "",
    last_name: "",
    mobile_number: "",
  });

  const handleChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };
  return (
    <Modal
      open={open}
      onCancel={closeModal}
      footer={null}
      bodyStyle={{ paddingTop: 40 }}
    >
      <div className="flex items-center mb-1" style={{ gap: "12px" }}>
        <Input
          name="first_name"
          className={`${styles.Input} mb-2`}
          onChange={handleChange}
          placeholder="First Name"
          value={state.first_name}
        />
        <Input
          name="last_name"
          className={`${styles.Input} mb-2`}
          onChange={handleChange}
          placeholder="Last Name"
          value={state.last_name}
        />
      </div>
      <Input
        name="mobile_number"
        className={`${styles.Input} mb-2`}
        onChange={handleChange}
        placeholder="Mobile Number"
        value={state.mobile_number}
      />
      <Button
        style_width={"100%"}
        style={{ maxWidth: "280px" }}
        style_backgroundColor={"type-secondary"}
        style_color={"white"}
        style_color_hover={"white"}
        style_color_active={"white"}
        style_marginTop="12px"
        style_fontWeight="bold"
      >
        Add New Staff
      </Button>
    </Modal>
  );
};

export default NewStaff;
